import { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { currentHostFrameContext } from '@canvas/canvas-state/host-api';

import { useDisplayPasteFlags } from './useDisplayPasteFlags';

type DspCopyHandler = (
  callback: () => boolean,
  hasNonEmptyAttachments: boolean
) => boolean;

/**
 * This provides a function called `attemptCopy` that takes a callback. The callback will be called if the user
 * has proper DSP permissions. If the user does not, it will display a flag.
 */
export const useCopyWithDsp = () => {
  const frameContext = useSnapshot(currentHostFrameContext);
  const isCopyDisabledByDSP =
    frameContext.data.dataSecurityPolicy?.attachmentDownload !== true;
  const showFlags = useDisplayPasteFlags(undefined);

  const attemptCopy: DspCopyHandler = useCallback(
    (callback, areNonEmptyAttachmentsSelected) => {
      if (isCopyDisabledByDSP && areNonEmptyAttachmentsSelected) {
        showFlags([
          {
            actionType: 'restrictedContentCantBeCopied',
            type: 'warning'
          }
        ]);
        return true;
      } else {
        return callback();
      }
    },
    [isCopyDisabledByDSP, showFlags]
  );

  return { attemptCopy };
};
